import * as analytics from "./util/segment";

export default class CfButton {
    mount() {
        if (window.cfButtons) {
            Object.keys(window.cfButtons).forEach(id => {
                const $button = $(`#${id}`);
    
                if ($button.length) {
                    const { jsonUrl, baseUrl, stackName } = window.cfButtons[id];
    
                    $.getJSON(jsonUrl, ({ S3URL }) => {
                        const href = `${baseUrl}?templateURL=${encodeURIComponent(
                            S3URL
                        )}&stackName=${encodeURIComponent(stackName)}`;
    
                        $button.attr("href", href);
    
                        $button.click(() => {
                            analytics.track({
                                action: "cloudformation-button-clicked",
                                category: "guides",
                                label: href
                            });
                        });
                    });
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./themes/docs/static/js/cf-button.js